import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useKioskManager } from '../../../hooks/useKioskManager';
import { ensureHttps } from '../../../utils/url';
import styles from './logo.module.scss';

type LogoProps = {
  imageURL?: string;
  companyName?: string;
};

const Logo: React.FC<LogoProps> = ({ imageURL, companyName }) => {
  const navigate = useNavigate();
  const { kiosk, kioskMode } = useKioskManager();

  const handleHome = () => !kioskMode && navigate('/');

  return (
    <div onClick={handleHome} className={styles.logo}>
      {imageURL ? (
        <img
          src={ensureHttps(imageURL)}
          alt={companyName}
          className={`${styles.logo} ${
            kiosk && kioskMode && styles[kiosk.model]
          }`}
        />
      ) : (
        <div className={styles.companyName}>{companyName}</div>
      )}
    </div>
  );
};

export default Logo;
